export default "__VITE_ASSET__D8iCth5Z__"